<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('reply.menu-enabled')"
    >
      <template slot="title">
        <b-button
          size="md"
          variant="dark"
          class="mx-md-1"
          @click="$router.push({name:'owner:instagram-posts'})"
        >
          {{ $t('reply.enable-new') }}
        </b-button>
      </template>
      <ok-table
        ref="datatable"
        :config="config"
        @edit="goEdit"
        @status="handleChangeStatus"
      >
        <template
          slot="post-column"
          slot-scope="{props}"
        >
          <a
            :href="props.row.media_link"
            target="_blank"
          >
            <template v-if="props.row.full_description">
              {{ props.row.description }}
            </template>
            <template v-else-if="props.row.post_thumb">
              <img
                class="img-thumbnail"
                style="height: 100px"
                :src="props.row.post_thumb"
              >
            </template>
            <template v-else>
              {{ props.row.description }}
            </template>
          </a>
        </template>
        <template
          slot="status-column"
          slot-scope="{props}"
        >
          <b-badge :variant="getStatusVariant(props.row)">
            {{ getStatusText(props.row) }}
          </b-badge>
        </template>
        <template
          slot="type-column"
          slot-scope="{props}"
        >
          <b-badge variant="primary">
            {{ $t(`reply.${props.row.type}`) }}
          </b-badge>
        </template>
        <template
          slot="actions-column"
          slot-scope="{props}"
        >
          <custom-actions>
            <b-dropdown-item
              @click.stop="goEdit(props)"
            >
              <feather-icon
                icon="Edit2Icon"
                class="mr-50"
              />
              <span>{{ $t('forms.edit') }}</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="props.row.status!==1"
              @click.stop="handleChangeStatus(props)"
            >
              <feather-icon
                :icon="props.row.status===0?'PauseIcon':'PlayIcon'"
                class="mr-50"
              />
              <span>{{ $t(`reply.${props.row.status===0?'stop':'start'}`) }}</span>
            </b-dropdown-item>
          </custom-actions>
        </template>
      </ok-table>
    </empty-card>
  </div>
</template>

<script>
import { BBadge, BButton, BDropdownItem } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import InstagramReplyApi from '@/api/instagram/reply'
import CustomActions from '@/@bya3/components/tables/ok-table/components/CustomActions'

export default {
  components: {
    CustomActions,
    EmptyCard,
    OkTable,
    BBadge,
    BButton,
    BDropdownItem,
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    forAdmin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      currentPageId: 'instagram/currentAccountId',
      currentPage: 'instagram/currentAccount',
    }),
  },
  watch: {
    currentPageId() {
      if (!this.forAdmin) this.refreshTable()
    },
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    getStatusVariant(report) {
      if (this.currentPage.replies_count < report.replies_count) return 'danger'
      switch (report.status) {
        case 1: return 'danger'
        case 2: return 'warning'
        default: return 'success'
      }
    },
    getStatusText(report) {
      if (this.currentPage.replies_count < report.replies_count) return this.$t('reply.is_enable_message')
      switch (report.status) {
        case 1: return this.$t('reply.stopped')
        case 2: return this.$t('reply.temp_stop')
        default: return this.$t('reply.running')
      }
    },
    goEdit(props) {
      this.$router.push({ name: 'owner:instagram-reply-edit', params: { id: props.row.post_id } })
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('reply.delete-reply-message'), {
        preConfirm: () => InstagramReplyApi.deleteReply(data.row.post_id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleChangeStatus(data) {
      const label = data.row.status === 0 ? 'stop' : 'start'
      this.$okConfirm(this.$t(`reply.${label}-reply-message`), {
        confirmButtonText: this.$t('forms.submit'),
        showCancel: true,
        preConfirm: () => InstagramReplyApi.changeReplyStatus(this.currentPageId, data.row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
